import { observable } from "../utils/observer";
import {
  alertConditionsDetailsMapper,
  assignedClientMapper,
  emergencyPlanMapper,
  healthInformationDetailsMapper,
  personalSupportDetailsMapper,
  technologyDetailsMapper,
} from "./wizard";
import { updateAssignedClient } from "./assignedClient";
import { updatePSDetails } from "./personalSupportDetails";
import { updateHIDetails } from "./healthInformationDetails";
import { updateDSDetails } from "./emergencyPlanning";
import { updateTechDetails } from "./technologyDetails";
import { updateACDetails } from "./alertConditionsDetails";
import { ROUTE_CODES } from "../routes/route-codes";

export const saveCarePlan = (clientId) => async (dispatch) => {
  // debugger;
  if (Object.keys(observable.notify()).length) {
    // variables
    const carePlan = observable.notify();
    const { prevStep, ref, ACCORDION_LIST } = carePlan;
    const activeElement = ACCORDION_LIST.find(
      (item) => item.stepId === prevStep,
    );
    const activeElementCode = activeElement?.code;

    if (carePlan && activeElementCode && Object.keys(carePlan)?.length > 0) {
      if (activeElementCode === ROUTE_CODES.ASSIGNED_CLIENT) {
        const assignedClientData = assignedClientMapper(carePlan);
        await dispatch(updateAssignedClient(clientId, assignedClientData));
      } else if (activeElementCode === "CareCircle") {
        // triggers submit DD-Board form
        ref?.current?.click();
      } else if (activeElementCode === ROUTE_CODES.EMERGENCY_PLANNING) {
        const disasterDetails = emergencyPlanMapper(carePlan);
        await dispatch(updateDSDetails(clientId, disasterDetails));
      } else if (activeElementCode === ROUTE_CODES.PERSONAL_SUPPORT_DETAILS) {
        const personalSupportDetails = personalSupportDetailsMapper(carePlan);
        await dispatch(updatePSDetails(clientId, personalSupportDetails));
      } else if (activeElementCode === ROUTE_CODES.TECHNOLOGY_DETAILS) {
        const technologyDetails = technologyDetailsMapper(carePlan);
        await dispatch(updateTechDetails(clientId, technologyDetails));
      } else if (activeElementCode === ROUTE_CODES.ALERT_CONDITIONS) {
        const alertConditionsDetails = alertConditionsDetailsMapper(carePlan);
        await dispatch(updateACDetails(clientId, alertConditionsDetails));
      } else if (activeElementCode === ROUTE_CODES.HEALTH_INFORMATION) {
        const healthInformationDetails =
          healthInformationDetailsMapper(carePlan);
        await dispatch(updateHIDetails(clientId, healthInformationDetails));
      }
    }
  }
};
